<template>
  <div id="comDetailBox" class="pageBox">
    <div class="searchWrap">
        <div class="row">
            <div class="itemWrap">
                <el-input v-model="keyword" placeholder="統一編號" style="width:35%;margin-right:15px;" clearable></el-input>                    
                <el-button style="margin-right: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
            </div> 
            <div class="itemWrap" style="justify-content: flex-end;">
                <el-button v-if="allowExportXls" :disabled="!canExportOverview" type="primary" icon="el-icon-tickets" @click="exportEXCEL">匯出公司概況表(excel)</el-button>
                <el-button :disabled="!canExportOverview" type="danger" icon="el-icon-tickets" @click="exportPDF">匯出公司概況表(pdf)</el-button>
            </div>   
        </div> 
    </div>

    <div class="content" v-if="comBriefVisible">
        <div class="section">
        <h2>一、客戶基本資料</h2>
        <div class="sectionItem">
            <el-descriptions v-if="biz_info_visible">
                <el-descriptions-item label="公司名稱">{{ basic_info.CUS_NAME }}</el-descriptions-item>
                <el-descriptions-item label="公司英文名稱">{{ basic_info.CUS_ENG_NAME }}</el-descriptions-item>
                <el-descriptions-item label="公司統一編號">{{ basic_info.CUS_IDN }}</el-descriptions-item>
                <el-descriptions-item label="公司設立日">{{ basic_info.CUS_BIRTHDAY }}</el-descriptions-item>
                <el-descriptions-item label="國別">{{ basic_info.CUS_COUNTRY_CODE }}</el-descriptions-item>
                <el-descriptions-item label="負責人">{{ basic_info.CUS_REP_NAME }}</el-descriptions-item>
                <el-descriptions-item label="行業別">{{ basic_info.CUS_IDU_NAME }}</el-descriptions-item>
                <el-descriptions-item label="組織型態">{{ basic_info.CUS_ORG_TYPE_NAME }}</el-descriptions-item>
                <el-descriptions-item label="客戶等級">{{ basic_info.CUS_GRADE }}</el-descriptions-item>
                <el-descriptions-item label="利害關係人">{{ basic_info.INTEREST_REL }}</el-descriptions-item>
                <el-descriptions-item label="債務協商">{{ basic_info.NOTE_L5 }}</el-descriptions-item>            
            </el-descriptions>
            <div v-else style="width: 100%;">
                <el-table border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" :row-class-name="getCreditSubTotalRowClass" style="width: 100%"  empty-text="暫無數據" :data="emptyArray"  :show-header="false">
                </el-table>            
            </div>            
            
        </div>      
        </div>   
        
        <div class="section2">
            <h2>二、營業狀況</h2>
            <div class="sectionHeaderRow">
                <h3 style="margin-bottom:15px;">個體營業狀況</h3>
                <div class="unitText">單位:新臺幣千元</div>
            </div>
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="business_status.individual" >                                                       
                <el-table-column label="年度"  prop="DATE_IFRS" min-width="12.5%">
                </el-table-column>                              
                <el-table-column class-name="align-right-column" label="營業收入" prop="SD1_IFRS"  min-width="12.5%">
                </el-table-column>              
                <el-table-column class-name="align-right-column" label="成長率"  prop="SD2_IFRS" min-width="12.5%"  >
                </el-table-column>                        
                <el-table-column class-name="align-right-column" label="營業毛利"  prop="SD3_IFRS" min-width="12.5%"  >                
                </el-table-column>     
                <el-table-column class-name="align-right-column" label="營業利益"  prop="SD4_IFRS" min-width="12.5%"  >
                </el-table-column>                   
                <el-table-column class-name="align-right-column" label="營業外收支淨額"  prop="SD9_IFRS" min-width="12.5%"  >
                </el-table-column>                     
                <el-table-column class-name="align-right-column" label="稅前損益"  prop="SD7_IFRS" min-width="12.5%"  >
                </el-table-column>                
                <el-table-column class-name="align-right-column" label="稅前損益率"  prop="SD8_IFRS" min-width="12.5%"  >
                </el-table-column>   
            </el-table> 
            <h4>{{ business_status.desc_IFRS }}</h4>                
            <div class="sectionHeaderRow">
                <h3 style="margin-bottom:15px;">合併營業狀況(IFRS)</h3>
                <div class="unitText">單位:新臺幣千元</div>
            </div>            
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="business_status.IFRS" >                                                       
                <el-table-column label="年度"  prop="DATE_IFRS" min-width="12.5%">
                </el-table-column>                              
                <el-table-column class-name="align-right-column" label="營業收入" prop="SD1_IFRS"  min-width="12.5%">
                </el-table-column>              
                <el-table-column class-name="align-right-column" label="成長率"  prop="SD2_IFRS" min-width="12.5%"  >
                </el-table-column>                        
                <el-table-column class-name="align-right-column" label="營業毛利"  prop="SD3_IFRS" min-width="12.5%"  >                
                </el-table-column>     
                <el-table-column class-name="align-right-column" label="營業利益"  prop="SD4_IFRS" min-width="12.5%"  >
                </el-table-column>                   
                <el-table-column class-name="align-right-column" label="營業外收支淨額"  prop="SD9_IFRS" min-width="12.5%"  >
                </el-table-column>     
                    <el-table-column class-name="align-right-column" label="稅前損益"  prop="SD7_IFRS" min-width="12.5%"  >
                </el-table-column>                
                <el-table-column class-name="align-right-column" label="稅前損益率"  prop="SD8_IFRS" min-width="12.5%"  >
                </el-table-column>   
            </el-table>    
            <!-- <h4>{{ business_status.desc }}</h4>     -->

        </div>    

        <div class="section3">
        <h2>三、主要業務貢獻度</h2>
            <div class="sectionHeaderRow">
                <h3>統計起訖日：{{ contribution.period }}</h3>
                <div class="unitText" style="text-decoration: underline;">單位:新臺幣元</div>
            </div>                    
        <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="contribution.detail" >                                                       
            <el-table-column label="業務群組-產品別"  prop="BUS_GROUP_LABEL_DESC" min-width="20%">
            </el-table-column>                              
            <el-table-column class-name="align-right-column" label="平均餘額／交易" prop="PROF_AVE_BALANCE"  min-width="10%">
            </el-table-column>              
            <el-table-column class-name="align-right-column" label="資金運用收入"  prop="PROF_FUND_INCOME" min-width="10%"  >
            </el-table-column>                        
            <el-table-column class-name="align-right-column" label="資金運用成本"  prop="PROF_FUND_COST" min-width="10%"  >                
            </el-table-column>     
            <el-table-column class-name="align-right-column" label="資金運用收益"  prop="PROF_FUND_PROF" min-width="10%"  >
            </el-table-column>                   
            <el-table-column class-name="align-right-column" label="手續費收益"  prop="PROF_CMS_PROF" min-width="10%"  >
            </el-table-column>     
            <el-table-column class-name="align-right-column" label="其他收入"  prop="PROF_OTHER_INCOME" min-width="10%"  >
            </el-table-column>                
            <el-table-column class-name="align-right-column" label="兌換收益"  prop="PROF_GA_LOS_XC" min-width="10%"  >
            </el-table-column>   
            <el-table-column class-name="align-right-column" label="貢獻度"  prop="PROF_CLIENT_PROF" min-width="10%"  >
            </el-table-column>   
            </el-table>         
        </div>
        <h4>註：本表相關資料僅列示至單位元，倘有完整數據需求，以CRM3系統為準</h4>        
        <h3 style="margin-bottom:15px;">主要業務貢獻度統計</h3>
        <el-descriptions v-if="contribution_statistics_visible">            
            <el-descriptions-item label="貢獻度合計">{{ contribution.statistics.ROA_CLIENT_PROF  }}</el-descriptions-item>
            <el-descriptions-item label="放款收益">{{ contribution.statistics.ROA_FUND_PROF_LOAN  }}</el-descriptions-item>
            <el-descriptions-item label="保證手續費收益">{{ contribution.statistics.ROA_1886  }}</el-descriptions-item>
            <el-descriptions-item label="一般手續費收益">{{ contribution.statistics.ROA_NON1886  }}</el-descriptions-item>
            <el-descriptions-item label="存款收益">{{ contribution.statistics.ROA_FUND_PROF_SAVING  }}</el-descriptions-item>
            <el-descriptions-item label="信用卡業務收益">{{ contribution.statistics.ROA_FUND_PROF_IC  }}</el-descriptions-item>
            <el-descriptions-item label="融資交易資金運用收益">{{ contribution.statistics.ROA_FUND_PROF_SMS }}</el-descriptions-item>            
            <el-descriptions-item label="ROA1">{{ contribution.statistics.ROA1  }}</el-descriptions-item>            
            <el-descriptions-item label="ROA2">{{ contribution.statistics.ROA2  }}</el-descriptions-item>            
            <el-descriptions-item label="ROA3">{{ contribution.statistics.ROA3 }}</el-descriptions-item>
        </el-descriptions>
        <div v-else>
            <el-table border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" :row-class-name="getCreditSubTotalRowClass" style="width: 100%"  empty-text="暫無數據" :data="emptyArray"  :show-header="false">
            </el-table>            
        </div>

        <div class="section4">
            
        <div class="sectionHeaderRow">
            <h2>四、授信往來情形</h2>     
            <div class="unitText">單位:新臺幣千元</div>
        </div>            

        
        <h3>{{ (credit_status.mainCustomer || '').trim() }} {{ credit_status.mainCustomerID }}</h3> 
        <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" :row-class-name="getCreditSubTotalRowClass" style="width: 100%"  empty-text="暫無數據" :data="credit_status.main" >                                                       
            <el-table-column label="分行別"  prop="CUS_BRANCH" min-width="10%">
            </el-table-column>
            <el-table-column label="授信項目"  prop="CREDIT_ITEM" min-width="10%">
            </el-table-column>                              
            <el-table-column class-name="align-right-column" label="訂約金額" prop="CONTRACT_AMOUNT"  min-width="10%">
            </el-table-column>              
            <el-table-column class-name="align-right-column" label="授信餘額"  prop="CREDIT_BAL" min-width="10%"  >
            </el-table-column>                        
            <el-table-column label="貸款期間"  prop="LOAN_TERM" min-width="20%"  >            
            </el-table-column>     
            <el-table-column label="擔保品"  prop="COLLATERAL" min-width="10%"  >
            </el-table-column>                   
            <el-table-column label="備註"  prop="REMARKS" min-width="10%"  >
            </el-table-column>     
        </el-table>         
              
        <div v-for="(childItems, idx) in credit_status.child" :key="childItems.CHILD_CUSIDN || idx">
            <!-- <h3>{{ (childItems[0].CUS_NAME || '').trim() }} ({{ childItems[0].CHILD_CUSIDN }})</h3>  -->
            <h3>{{ (childItems[0].CUS_NAME || '').trim() }} 
                <span v-if="childItems[0].CHILD_CUSIDN">({{ childItems[0].CHILD_CUSIDN }})</span>
            </h3> 
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" :row-class-name="getCreditSubTotalRowClass" style="width: 100%"  empty-text="暫無數據" :data="childItems" >                                                       
                <el-table-column label="分行別"  prop="CUS_BRANCH" min-width="10%">
                </el-table-column>
                <el-table-column label="授信項目"  prop="CREDIT_ITEM" min-width="10%">
                </el-table-column>                                   
                <el-table-column class-name="align-right-column" label="訂約金額" prop="CONTRACT_AMOUNT"  min-width="10%">
                </el-table-column>              
                <el-table-column class-name="align-right-column" label="授信餘額"  prop="CREDIT_BAL" min-width="10%"  >
                </el-table-column>                        
                <el-table-column label="貸款期間"  prop="LOAN_TERM" min-width="20%"  >                
                </el-table-column>     
                <el-table-column label="擔保品"  prop="COLLATERAL" min-width="10%"  >
                </el-table-column>                   
                <el-table-column label="備註"  prop="REMARKS" min-width="10%"  >
                </el-table-column>     
            </el-table>
        </div>

        <br/>
        <el-table border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" :row-class-name="getCreditSubTotalRowClass" style="width: 100%"  empty-text="暫無數據" :data="credit_status.all_subTotal" v-if="credit_status.all_subTotal.length > 0" :show-header="false">
            <el-table-column label="分行別"  prop="CUS_BRANCH" min-width="10%">
            </el-table-column>
            <el-table-column label="授信項目"  prop="SUM_CREDIT_ITEM" min-width="10%">
            </el-table-column>                              
            <el-table-column class-name="align-right-column" label="訂約金額" prop="SUM_CONTRACT_AMOUNT"  min-width="10%">
            </el-table-column>              
            <el-table-column class-name="align-right-column" label="授信餘額"  prop="SUM_CREDIT_BAL" min-width="10%"  >
            </el-table-column>                        
            <el-table-column label="貸款期間"  prop="SUM_LOAN_TERM" min-width="20%"  >            
            </el-table-column>     
            <el-table-column label="擔保品"  prop="SUM_COLLATERAL_RATIO" min-width="10%"  >
            </el-table-column>                   
            <el-table-column label="備註"  prop="REMARKS" min-width="10%"  >
            </el-table-column> 
        </el-table>
        </div>         
    </div>
   
    <br/><br/><br/><br/><br/>
  </div>
</template>

<script>
import { InfiniteScroll } from 'element-ui';
import { notify } from '../../utils/notify';
import { exportCompanyOverviewPdf } from '../../utils/companyOverviewPdfExporter';
import { exportCompanyOverviewExcel } from '../../utils/companyOverviewExcelExporter';
import { parse } from '@fortawesome/fontawesome-svg-core';

export default {

    data() {
        return {
        
            allowExportXls: false,
            keyword: '',
            comBriefVisible: false,
            tableData: [],

            emptyArray: [],
            biz_info_visible: false,
            contribution_statistics_visible: false,

            basic_info:[], // 公司基本資料
            business_status:{
                individual:[], // 營業狀況-個體營業狀況
                IFRS:[],    // 營業狀況-合併營業狀況(IFRS)
                desc:"",  // 營業狀況-說明文字
                desc_IFRS:""  // 營業狀況-說明文字(IFRS)
            },
            contribution: { // 主要業務貢獻度
                period: "", // 統計起訖日
                detail:[], // 主要業務貢獻度明細
                statistics:[] // 主要業務貢獻度統計
            }, 
            credit_status:{ // 授信往來情形
                mainCustomer:"", // 主要授信往來客戶名稱
                mainCustomerID:"", // 主要授信往來客戶統編
                main:[], // 主要授信往來
                main_subTotal:[], // 主要授信往來小計
                child:[], // 關係戶授信往來
                child_subTotal:[], // 關係戶授信往來小計
                all_subTotal:[] // 全部授信往來小計
            } 

        }
    },

    computed: {
        canExportOverview() {
            if (!this.comBriefVisible) {
                return false;
            }

            const hasBasicInfo = this.basic_info && Object.keys(this.basic_info).length > 0;
            const hasBusinessStatus =
                Array.isArray(this.business_status.individual) && this.business_status.individual.length > 0 ||
                Array.isArray(this.business_status.IFRS) && this.business_status.IFRS.length > 0;
            const hasContribution =
                Array.isArray(this.contribution.detail) && this.contribution.detail.length > 0;
            const hasCreditStatus =
                Array.isArray(this.credit_status.main) && this.credit_status.main.length > 0 ||
                Array.isArray(this.credit_status.child) && this.credit_status.child.length > 0 ||
                Array.isArray(this.credit_status.all_subTotal) && this.credit_status.all_subTotal.length > 0;

            return hasBasicInfo || hasBusinessStatus || hasContribution || hasCreditStatus;
        }
    },

    methods: {

        getFunction() {
            // const roleName = this.$store.getters.userRole || '';
            const roleName = window.localStorage.getItem('userRole') || '';
            console.log('從 localStorage 取得的 userRole:', roleName);
            // UC、HC、HE、HC1、HE 部門可以選取allowExportXls，其他角色不顯示
            if(roleName.includes('HD') || roleName.includes('UC') || roleName.includes('HC') || roleName.includes('HE') || roleName.includes('HC1') ){
                this.allowExportXls = true;
            } else {
                this.allowExportXls = false;
            }   

        },

        getCreditSubTotalRowClass({ row }) {
            const isSubTotal = row && row.CREDIT_ITEM === '小計';
            const isGrandTotal = row && (row.SUM_CREDIT_ITEM === '總計' || row.CREDIT_ITEM === '總計');
            return (isSubTotal || isGrandTotal) ? 'credit-subtotal-row' : '';
        },

        formatNumberWithThousands(value, removeDecimal = false) {
            if (value === null || value === undefined || value === '') {
                return '';
            }

            const normalizedValue = typeof value === 'string'
                ? value.replace(/,/g, '').trim()
                : value;

            if (normalizedValue === '') {
                return '';
            }

            const numericValue = Number(normalizedValue);
            if (!Number.isFinite(numericValue)) {
                return value;
            }

            const formatted = numericValue.toLocaleString();
            if (removeDecimal) {
                return formatted.replace(/\.\d+/g, '');
            }
            return formatted;
        },

        shouldShowCompanyProfileNotice(response) {
            const statusCode = Number(response && response.statuscode);
            const message = String((response && response.message) || '');
            const errors = Array.isArray(response && response.errors)
                ? response.errors.filter(error => !!error)
                : [];

            return statusCode === 500 || errors.length > 0 || message.includes('無資料');
        },

        buildCompanyProfileNoticeMessage(errors, fallbackText) {
            if (!Array.isArray(errors) || errors.length === 0) {
                return fallbackText || '查無可顯示內容';
            }

            return this.$createElement(
                'div',
                errors.map((error, index) => this.$createElement('div', { key: `company-profile-notice-${index}` }, error))
            );
        },

        showCompanyProfileNotice(response) {
            if (!this.shouldShowCompanyProfileNotice(response)) {
                return;
            }

            const title = String((response && response.message) || '系統通知');
            const errors = Array.isArray(response && response.errors)
                ? response.errors.filter(error => !!error)
                : [];
            const statusCode = Number(response && response.statuscode);
            const fallbackText = title.includes('無資料') ? '目前查無資料' : '目前沒有額外錯誤資訊';

            notify({
                title,
                message: this.buildCompanyProfileNoticeMessage(errors, fallbackText),
                type: statusCode === 500 ? 'error' : 'warning'
            });
        },

        async doSearch() {
            if( this.keyword == null || String(this.keyword).trim() === '') {
                notify({ title: '請輸入統一編號', type: 'warning' });
                return;
            }
            await this.getList();       
            this.comBriefVisible = true;
        },

        async getList() {
            
            
            const qry = {
                UniComNm: this.keyword,
            };

            const mockResponse2 = {
                statuscode: 200,
                message: '部分資料查詢失敗',
                data: {
                    basic_info: {
                        DETAILDATA: [
                            {
                                CUS_NAME: '測試科技股份有限公司',
                                CUS_ENG_NAME: 'Mock Tech Co., Ltd.',
                                CUS_IDN: '12345678',
                                CUS_BIRTHDAY: '20100115',
                                CUS_COUNTRY_CODE: 'TW',
                                CUS_REP_NAME: '王小明',
                                CUS_REP_IDN: 'A123456789',
                                CUS_IDU_NAME: '半導體業',
                                CUS_ORG_TYPE_NAME: '股份有限公司',
                                CUS_GRADE: 'A',
                                INTEREST_REL: '否',
                                NOTE_L5: '無',
                                DW_UPD_DTTM: '2026-04-17 09:00:00',
                            },
                        ],
                    },
                    business_status: [
                        {
                            data1: [
                                {
                                    ID: 1,
                                    CUSTID: '12345678',
                                    CASEID: 'CASE-MOCK2',
                                    IFRS_SRC: '1',
                                    DATE_IFRS: '2024',
                                    S01_IFRS: '150000',
                                    S02_IFRS: '8.5',
                                    S03_IFRS: '34000',
                                    S04_IFRS: '22000',
                                    S07_IFRS: '1000',
                                    S08_IFRS: '21000',
                                    S09_IFRS: '13.2'
                                },
                                {
                                    ID: 2,
                                    CUSTID: '12345678',
                                    CASEID: 'CASE-MOCK2',
                                    IFRS_SRC: '2',
                                    DATE_IFRS: '2024',
                                    S01_IFRS: '200000',
                                    S02_IFRS: '10.2',
                                    S03_IFRS: '45000',
                                    S04_IFRS: '30000',
                                    S07_IFRS: '1500',
                                    S08_IFRS: '28500',
                                    S09_IFRS: '14.3'
                                }
                            ],
                            data2: [
                                {
                                    R01: '2024',
                                    R02: '150000',
                                    R03: '8.5',
                                    R04: '2023',
                                    R05: '138200',
                                    R06: '108.5',
                                    R01_IFRS: '2024',
                                    R02_IFRS: '200000',
                                    R03_IFRS: '-10.2',
                                    R04_IFRS: '2023',
                                    R05_IFRS: '181500',
                                    R06_IFRS: '110.2'
                                }
                            ]
                        }
                    ],
                    contribution: {
                        detail: {
                            DETAILDATA: []
                        },
                        statistics: {
                            DETAILDATA: []
                        },
                    },
    "credit_status": {
        "DETAILDATA": [
            {
                "MAIN_DETAILDATA": [
                    {
                        "CUS_NAME": "台灣科技股份有限公司                                                         ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "短期週轉金貸款",
                        "CONTRACT_AMOUNT": 50000000,
                        "CREDIT_BAL": 48000000,
                        "LOAN_SDT": "20250101",
                        "LOAN_DDT": "20251231",
                        "COLLATERAL": "土地",
                        "COLLATERAL_BAL": 60000000,
                        "CUS_BAL": 50000000,
                        "COLLATERAL_RATIO": 120,
                        "PROF_CLIENT_PROF": 0.85,
                        "SUM_CONTRACT_AMOUNT": 50000000,
                        "SUM_CREDIT_BAL": 48000000,
                        "DW_UPD_DTTM": "2026-01-13 15:02:29",
                        "LOAN_TERM": "20250101 至 20251231"
                    },
                    {
                        "CUS_NAME": "台灣科技股份有限公司                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "中期設備貸款",
                        "CONTRACT_AMOUNT": 30000000,
                        "CREDIT_BAL": 25000000,
                        "LOAN_SDT": "20240601",
                        "LOAN_DDT": "20270601",
                        "COLLATERAL": "機器設備",
                        "COLLATERAL_BAL": 35000000,
                        "CUS_BAL": 30000000,
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.75,
                        "SUM_CONTRACT_AMOUNT": 30000000,
                        "SUM_CREDIT_BAL": 25000000,
                        "DW_UPD_DTTM": "2026-01-13 15:02:29",
                        "LOAN_TERM": "20240601 至 20270601"
                    },
                    {
                        "CUS_NAME": "台灣科技股份有限公司 ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "應收帳款承購",
                        "CONTRACT_AMOUNT": 20000000,
                        "CREDIT_BAL": 18000000,
                        "LOAN_SDT": "20250201",
                        "LOAN_DDT": "20250731",
                        "COLLATERAL": "應收帳款",
                        "COLLATERAL_BAL": 22000000,
                        "CUS_BAL": 20000000,
                        "COLLATERAL_RATIO": 110,
                        "PROF_CLIENT_PROF": 0.65,
                        "SUM_CONTRACT_AMOUNT": 20000000,
                        "SUM_CREDIT_BAL": 18000000,
                        "DW_UPD_DTTM": "2026-01-13 15:02:29",
                        "LOAN_TERM": "20250201 至 20250731"
                    },
                    {
                        "CUS_NAME": "台灣科技股份有限公司 ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "進口信用狀額度",
                        "CONTRACT_AMOUNT": 15000000,
                        "CREDIT_BAL": 12000000,
                        "LOAN_SDT": "20250101",
                        "LOAN_DDT": "20251231",
                        "COLLATERAL": "存貨",
                        "COLLATERAL_BAL": 18000000,
                        "CUS_BAL": 15000000,
                        "COLLATERAL_RATIO": 120,
                        "PROF_CLIENT_PROF": 0.55,
                        "SUM_CONTRACT_AMOUNT": 15000000,
                        "SUM_CREDIT_BAL": 12000000,
                        "DW_UPD_DTTM": "2026-01-13 15:02:29",
                        "LOAN_TERM": "20250101 至 20251231"
                    },
                    {
                        "CREDIT_ITEM": "小計",
                        "CONTRACT_AMOUNT": 115000000,
                        "CREDIT_BAL": 103000000,
                        "LOAN_TERM": "本案擔保比率： 117.5%",
                        "COLLATERAL": "貢獻度：0.7",
                        "REMARKS": ""
                    }
                ],
                "CHILD_DETAILDATA": [
                    {
                        "CUS_NAME": "台灣科技關係企業甲                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "短期借款",
                        "CONTRACT_AMOUNT": 15000000,
                        "CREDIT_BAL": 14000000,
                        "LOAN_SDT": "20250101",
                        "LOAN_DDT": "20251231",
                        "COLLATERAL": "保證",
                        "COLLATERAL_BAL": 18000000,
                        "CUS_BAL": 15000000,
                        "COLLATERAL_RATIO": 120,
                        "PROF_CLIENT_PROF": 0.45,
                        "SUM_CONTRACT_AMOUNT": 15000000,
                        "SUM_CREDIT_BAL": 14000000,
                        "CHILD_CUSIDN": "9876543210",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20250101 至 20251231"
                    },
                    {
                        "CUS_NAME": "台灣科技關係企業甲 ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "設備貸款",
                        "CONTRACT_AMOUNT": 10000000,
                        "CREDIT_BAL": 9000000,
                        "LOAN_SDT": "20240801",
                        "LOAN_DDT": "20270731",
                        "COLLATERAL": "機器設備",
                        "COLLATERAL_BAL": 12000000,
                        "CUS_BAL": 10000000,
                        "COLLATERAL_RATIO": 120,
                        "PROF_CLIENT_PROF": 0.35,
                        "SUM_CONTRACT_AMOUNT": 10000000,
                        "SUM_CREDIT_BAL": 9000000,
                        "CHILD_CUSIDN": "9876543210",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20240801 至 20270731"
                    },
                    {
                        "CUS_NAME": "台灣科技關係企業乙                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "週轉性貸款",
                        "CONTRACT_AMOUNT": 12000000,
                        "CREDIT_BAL": 11000000,
                        "LOAN_SDT": "20250201",
                        "LOAN_DDT": "20260131",
                        "COLLATERAL": "應收帳款",
                        "COLLATERAL_BAL": 14000000,
                        "CUS_BAL": 12000000,
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "CHILD_CUSIDN": "9876543211",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20250201 至 20260131"
                    },
                    {
                        "CUS_NAME": "台灣科技關係企業D                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "週轉性貸款",
                        "CONTRACT_AMOUNT": 12000000,
                        "CREDIT_BAL": 11000000,
                        "LOAN_SDT": "20250201",
                        "LOAN_DDT": "20260131",
                        "COLLATERAL": "應收帳款",
                        "COLLATERAL_BAL": 14000000,
                        "CUS_BAL": 12000000,
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "CHILD_CUSIDN": "D",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20250201 至 20260131"
                    },
                    {
                        "CUS_NAME": "台灣科技關係企業E                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "週轉性貸款",
                        "CONTRACT_AMOUNT": 12000000,
                        "CREDIT_BAL": 11000000,
                        "LOAN_SDT": "20250201",
                        "LOAN_DDT": "20260131",
                        "COLLATERAL": "應收帳款",
                        "COLLATERAL_BAL": 14000000,
                        "CUS_BAL": 12000000,
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "CHILD_CUSIDN": "E",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20250201 至 20260131"
                    },
                    {
                        "CUS_NAME": "台灣科技關係企業A                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "週轉性貸款",
                        "CONTRACT_AMOUNT": 12000000,
                        "CREDIT_BAL": 11000000,
                        "LOAN_SDT": "20250201",
                        "LOAN_DDT": "20260131",
                        "COLLATERAL": "應收帳款",
                        "COLLATERAL_BAL": 14000000,
                        "CUS_BAL": 12000000,
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "CHILD_CUSIDN": "A",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20250201 至 20260131"
                    },      
                    {
                        "CUS_NAME": "台灣科技關係企業B                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "週轉性貸款",
                        "CONTRACT_AMOUNT": 12000000,
                        "CREDIT_BAL": 11000000,
                        "LOAN_SDT": "20250201",
                        "LOAN_DDT": "20260131",
                        "COLLATERAL": "應收帳款",
                        "COLLATERAL_BAL": 14000000,
                        "CUS_BAL": 12000000,
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "CHILD_CUSIDN": "B",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20250201 至 20260131"
                    },  
                    {
                        "CUS_NAME": "台灣科技關係企業C                                                          ",
                        "CUSIDN": "1234567890",
                        "CUS_BRANCH": "001",
                        "CREDIT_ITEM": "週轉性貸款",
                        "CONTRACT_AMOUNT": 12000000,
                        "CREDIT_BAL": 11000000,
                        "LOAN_SDT": "20250201",
                        "LOAN_DDT": "20260131",
                        "COLLATERAL": "應收帳款",
                        "COLLATERAL_BAL": 14000000,
                        "CUS_BAL": 12000000,
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "CHILD_CUSIDN": "C",
                        "DW_UPD_DTTM": "2026-01-13 15:03:46",
                        "LOAN_TERM": "20250201 至 20260131"
                    },                                                                                
                ],
                "MAIN_SUBTOTAL": [
                    {
                        "CUSIDN": "1234567890",
                        "COLLATERAL_RATIO": 117.5,
                        "PROF_CLIENT_PROF": 10000.7,
                        "SUM_CONTRACT_AMOUNT": 115000000,
                        "SUM_CREDIT_BAL": 103000000,
                        "DW_UPD_DTTM": "2026-01-13 15:05:01"
                    }
                ],
                "CHILD_SUBTOTAL": [
                    {
                        "CUSIDN": "1234567890",
                        "CHILD_CUSIDN": "9876543210",
                        "COLLATERAL_RATIO": 120,
                        "PROF_CLIENT_PROF": 110.45,
                        "SUM_CONTRACT_AMOUNT": 25000000,
                        "SUM_CREDIT_BAL": 23000000,
                        "DW_UPD_DTTM": "2026-01-13 15:03:46"
                    },
                    {
                        "CUSIDN": "1234567890",
                        "CHILD_CUSIDN": "9876543211",
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "DW_UPD_DTTM": "2026-01-13 15:03:46"
                    },
                    {
                        "CUSIDN": "1234567890",
                        "CHILD_CUSIDN": "A",
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "DW_UPD_DTTM": "2026-01-13 15:03:46"
                    },
                    {
                        "CUSIDN": "1234567890",
                        "CHILD_CUSIDN": "B",
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "DW_UPD_DTTM": "2026-01-13 15:03:46"
                    },
                    {
                        "CUSIDN": "1234567890",
                        "CHILD_CUSIDN": "C",
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "DW_UPD_DTTM": "2026-01-13 15:03:46"
                    },
                    {
                        "CUSIDN": "1234567890",
                        "CHILD_CUSIDN": "D",
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "DW_UPD_DTTM": "2026-01-13 15:03:46"
                    },
                    {
                        "CUSIDN": "1234567890",
                        "CHILD_CUSIDN": "E",
                        "COLLATERAL_RATIO": 116.67,
                        "PROF_CLIENT_PROF": 0.4,
                        "SUM_CONTRACT_AMOUNT": 12000000,
                        "SUM_CREDIT_BAL": 11000000,
                        "DW_UPD_DTTM": "2026-01-13 15:03:46"
                    }					
                ],
                "ALL_SUBTOTAL": [
                    {
                        "CUSIDN": "1234567890",
                        "COLLATERAL_RATIO": 118.42,
                        "PROF_CLIENT_PROF": 12300.6,
                        "SUM_CONTRACT_AMOUNT": 152000000,
                        "SUM_CREDIT_BAL": 137000000,
                        "DW_UPD_DTTM": "2026-01-13 15:06:29"
                    }
                ]
            }
        ]
    }
                },
                errors: [
                    '授信往來情形: API 請求逾時 (超過 30 秒)',
                    '主要業務貢獻度: 無法連線到 API 伺服器'
                ]
            };


            const mockResponse3 = {
                statuscode: 200,
                message: '查詢成功（無資料）',
                data: {
                    basic_info: {},
                    business_status: [
                        {
                            data1: [
                                {
                                    ID: 1,
                                    CUSTID: '12345678',
                                    CASEID: 'CASE-MOCK2',
                                    IFRS_SRC: '1',
                                    DATE_IFRS: '2025',
                                    S01_IFRS: '150000',
                                    S02_IFRS: '8.5',
                                    S03_IFRS: '34000',
                                    S04_IFRS: '22000',
                                    S07_IFRS: '1000',
                                    S08_IFRS: '21000',
                                    S09_IFRS: '13.2'
                                },
                                {
                                    ID: "",
                                    CUSTID: '',
                                    CASEID: '',
                                    IFRS_SRC: '',
                                    DATE_IFRS: '',
                                    S01_IFRS: '',
                                    S02_IFRS: '',
                                    S03_IFRS: '',
                                    S04_IFRS: '',
                                    S07_IFRS: '',
                                    S08_IFRS: '',
                                    S09_IFRS: ''
                                }
                            ],
                            data2: [

                            ]
                        }
                    ],
                    contribution: {
                        detail: {
                            DETAILDATA: []
                        },
                        statistics: {
                            DETAILDATA: []
                        },
                    },
                    credit_status: {
                        DETAILDATA: []
                    },
                },
            };

            const mockResponse4 = {
                statuscode: 500,
                message: '所有底層連線失敗',
                data: {
                    basic_info: {},
                    business_status: [],
                    contribution: {
                        detail: {
                            DETAILDATA: []
                        },
                        statistics: {
                            DETAILDATA: []
                        },
                    },
                    credit_status: {
                        DETAILDATA: [],
                    },
                },
                errors: [
                    '客戶基本資料: API 回應錯誤 (HTTP 502)',
                    '營業狀況: ELN API 請求逾時',
                    '主要業務貢獻度: API 回應錯誤 (HTTP 502)',
                    '授信往來情形: API 回應錯誤 (HTTP 502)'
                ]
            };

            const keyword = String(this.keyword || '').trim();
            const normalizedKeyword = keyword.toUpperCase();
            const mockResponseMap = {
                MOCK2: mockResponse2,
                MOCK3: mockResponse3,
                MOCK4: mockResponse4
            };
            const isMockCase = Object.prototype.hasOwnProperty.call(mockResponseMap, normalizedKeyword);
            try {
                this.$store.dispatch("loadingHandler", true);
                const response = isMockCase
                    ? mockResponseMap[normalizedKeyword]
                    : await this.$api.apidata.get_credit_transaction(qry);
                this.$store.dispatch("loadingHandler", false);                        
                //console.log('查詢參數', qry);                    
                //console.log('API response', response);

                const statusCode = Number(response && response.statuscode);

                if (statusCode === 200 || statusCode === 500) {
                    // 處理公司概況表資料，500 也可能帶有可顯示的空殼資料與錯誤明細
                    //console.log('取得公司詳細資料成功', response.data);
                    if (isMockCase) {
                        //console.log(`命中公司概況表 ${normalizedKeyword} 測試案例，使用固定格式回應`);
                    }

                    const payload = response && response.data ? response.data : {};
                    console.log("payload",payload)
                    // 共有四個段落資料需要處理
                    // 1. 基本資料 basic_info
                    this.basic_info = (payload.basic_info && Array.isArray(payload.basic_info.DETAILDATA) && payload.basic_info.DETAILDATA.length > 0)
                        ? payload.basic_info.DETAILDATA[0]
                        : {};

                    this.biz_info_visible = false;
                    Object.keys(this.basic_info).forEach(key => {
                        // 若全部的數字都是 null 或 ""，則不顯示統計區塊
                        if (this.basic_info[key] !== null && this.basic_info[key] !== undefined && this.basic_info[key] !== '') {
                            this.biz_info_visible = true;
                        }
                    });                    

                    // 2. 營業狀況 business_status
                    // 2.1 個體營業狀況 及 合併營業狀況(IFRS)
                    // data2與data1是1對多的關係。
                    // data1中IFRS_SRC= 1個體IFRS時，表示個體營業狀況，      取DATE_IFRS及S01_IFRS~S09_IFRS呈現。
                    // data1中IFRS_SRC= 2合併IFRS時，表示合併營業狀況(IFRS)，取DATE_IFRS及S01_IFRS~S09_IFRS呈現。
                    // data2表示的是個體營業狀況的彙整資料(調整如附，之前報表是放在合併營業狀況底下)，取R01_IFRS~ R06_IFRS呈現。

                    this.business_status.individual = []; // 清空陣列
                    this.business_status.IFRS = []; // 清空陣列

                    // 先檢查 response.data.business_status 是否存在且為陣列，才讀取 data1
                    let data1 = null;
                    if (Array.isArray(payload.business_status) && payload.business_status.length > 0) {
                        data1 = payload.business_status[0].data1;
                    }

                    if (data1) {
                        console.log('營業狀況data1', data1);
                        data1.forEach(item => {
                                // S01_IFRS, S03_IFRS, S04_IFRS, S07_IFRS, S08_IFRS 需要轉成數字, 並加上千位元，S02_IFRS、S09_IFRS要加上百分比符號（%），如果是 null 或 undefined 則顯示空字串。
                                item.S01_IFRS = item.S01_IFRS != null ? Number(item.S01_IFRS).toLocaleString() : '';
                                item.S03_IFRS = item.S03_IFRS != null ? Number(item.S03_IFRS).toLocaleString() : '';
                                item.S04_IFRS = item.S04_IFRS != null ? Number(item.S04_IFRS).toLocaleString() : '';
                                item.S07_IFRS = item.S07_IFRS != null ? Number(item.S07_IFRS).toLocaleString() : '';
                                item.S09_IFRS = item.S09_IFRS != null ? Number(item.S09_IFRS).toLocaleString() : '';
                                if(item.IFRS_SRC == '1') {
                                    // 個體IFRS                            
                                    const individualItem = {
                                        ID: item.ID,CUSTID: item.CUSTID,CASEID: item.CASEID,DATE_IFRS: item.DATE_IFRS,
                                        SD1_IFRS: item.S01_IFRS ,SD2_IFRS: item.S02_IFRS ,SD3_IFRS: item.S03_IFRS,SD4_IFRS: item.S04_IFRS,SD7_IFRS: item.S07_IFRS,SD8_IFRS: item.S08_IFRS,SD9_IFRS: item.S09_IFRS };                            
                                        if( individualItem.SD2_IFRS == null || individualItem.SD2_IFRS === undefined || individualItem.SD2_IFRS === '' ) {
                                            individualItem.SD2_IFRS = '';
                                        }
                                        else {
                                            individualItem.SD2_IFRS = individualItem.SD2_IFRS + ' %';
                                        }
                                        if( individualItem.SD8_IFRS == null || individualItem.SD8_IFRS == undefined || individualItem.SD8_IFRS === '' ) {
                                            individualItem.SD8_IFRS = '';
                                        }
                                        else {
                                            individualItem.SD8_IFRS = individualItem.SD8_IFRS + ' %';
                                        }
                                        // DATE_IFRS 長度等於 7 時顯示為 XXX年YY月ZZ日；大於 7 時沿用既有區間格式。
                                        if( individualItem.DATE_IFRS && individualItem.DATE_IFRS.length === 7 ) {
                                            const year = individualItem.DATE_IFRS.substring(0,3);
                                            const month = individualItem.DATE_IFRS.substring(3,5);
                                            const day = individualItem.DATE_IFRS.substring(5,7);
                                            individualItem.DATE_IFRS = `${year}年${month}月${day}日`;
                                        }
                                        else if( individualItem.DATE_IFRS && individualItem.DATE_IFRS.length > 7 ) {
                                            const year = individualItem.DATE_IFRS.substring(0,3);
                                            const endmonth = individualItem.DATE_IFRS.substring(3,5);
                                            const startmonth = individualItem.DATE_IFRS.substring(7,9);
                                            individualItem.DATE_IFRS = `${year}年${startmonth}月 - ${endmonth}月`;
                                        }

                                    this.business_status.individual.push(individualItem);
                                }
                                if(item.IFRS_SRC == '2') {
                                    // 合併IFRS       
                                    console.log('處理合併營業狀況2', item);                     
                                    const IFRSItem = {
                                        ID: item.ID,CUSTID: item.CUSTID,CASEID: item.CASEID,DATE_IFRS: item.DATE_IFRS,
                                        SD1_IFRS: item.S01_IFRS,SD2_IFRS: item.S02_IFRS ,SD3_IFRS: item.S03_IFRS,SD4_IFRS: item.S04_IFRS,SD7_IFRS: item.S07_IFRS,SD8_IFRS: item.S08_IFRS,SD9_IFRS: item.S09_IFRS};
                                    // console.log('IFRSItem2', IFRSItem);
                                        if( IFRSItem.SD2_IFRS == null || IFRSItem.SD2_IFRS === undefined || IFRSItem.SD2_IFRS === '' ) {
                                            IFRSItem.SD2_IFRS = '';
                                        }
                                        else {
                                            IFRSItem.SD2_IFRS = IFRSItem.SD2_IFRS + ' %';
                                        }
                                        if( IFRSItem.SD8_IFRS == null || IFRSItem.SD8_IFRS === undefined || IFRSItem.SD8_IFRS === '' ) {
                                            IFRSItem.SD8_IFRS = '';
                                        }
                                        else {
                                            IFRSItem.SD8_IFRS = IFRSItem.SD8_IFRS + ' %';
                                        }
                                        if( IFRSItem.DATE_IFRS && IFRSItem.DATE_IFRS.length === 7 ) {
                                            const year = IFRSItem.DATE_IFRS.substring(0,3);
                                            const month = IFRSItem.DATE_IFRS.substring(3,5);
                                            const day = IFRSItem.DATE_IFRS.substring(5,7);
                                            IFRSItem.DATE_IFRS = `${year}年${month}月${day}日`;
                                        }
                                        else if( IFRSItem.DATE_IFRS && IFRSItem.DATE_IFRS.length > 7 ) {
                                            const year = IFRSItem.DATE_IFRS.substring(0,3);
                                            const endmonth = IFRSItem.DATE_IFRS.substring(3,5);
                                            const startmonth = IFRSItem.DATE_IFRS.substring(7,9);
                                            IFRSItem.DATE_IFRS = `${year}年${startmonth}月 - ${endmonth}月`;
                                        }                                        
                                    this.business_status.IFRS.push(IFRSItem);
                                }

                            } 
                        );


                    }

                    // 2.2 說明文字
                    // 先安全取得 data2，避免 response 或 business_status 結構缺漏導致 runtime error
                    let data2 = null;
                    if (Array.isArray(payload.business_status) && payload.business_status.length > 0) {
                        data2 = payload.business_status[0].data2;
                    }
                    const item = (Array.isArray(data2) && data2.length > 0) ? data2[0] : null;
                    if (item) {
                        console.log('營業狀況data2', item);
                        const desc = `${item.R01} 申報營業額 ${item.R02} 千元，與上年度同期比較增加 ${item.R03}％ 為 ${item.R04}年全年度申報營業額 ${item.R05}千元之( ${item.R06}％)。`
                        this.business_status.desc = desc;
                        let yearPeriod = "";
                        let allyear = "";
                        
                        if( item.R01_IFRS && item.R01_IFRS.length > 7 ) {
                            const year = item.R01_IFRS.substring(0,3);
                            const startmonth = item.R01_IFRS.substring(3,5);
                            const endmonth = item.R01_IFRS.substring(6,8);
                            yearPeriod = `${year}年${startmonth}月 ~ ${endmonth}月`;
                        }                       
                        console.log('處理合併營業狀況說明文字的R04_IFRS', item.R04_IFRS);
                        if( item.R04_IFRS && item.R04_IFRS.length >= 3 ) {
                            
                            const year = item.R04_IFRS.substring(0,3);                                
                            allyear = `${year}`;
                        } 

                        const r03IfrsNumber = Number(item.R03_IFRS);
                        const isR03IfrsNumber = Number.isFinite(r03IfrsNumber);
                        const r03IfrsChangeText = isR03IfrsNumber
                            ? (r03IfrsNumber >= 0 ? `增加 ${r03IfrsNumber}％` : `減少 ${Math.abs(r03IfrsNumber)}％`)
                            : `增加 ${item.R03_IFRS}％`;
                        const r02IfrsFormatted = this.formatNumberWithThousands(item.R02_IFRS);
                        const r05IfrsFormatted = this.formatNumberWithThousands(item.R05_IFRS);

                        const desc_IFRS = `${yearPeriod} 申報營業額 ${r02IfrsFormatted} 千元，與上年度同期比較${r03IfrsChangeText} ，為 ${allyear}年全年度申報營業額 ${r05IfrsFormatted}千元之(${item.R06_IFRS}％)。`
                        this.business_status.desc_IFRS = desc_IFRS;
                    } else {
                        this.business_status.desc = '';
                        this.business_status.desc_IFRS = '';
                    }
                    // 3. 主要業務貢獻度 contribution
                    const contributionDetail = payload.contribution && payload.contribution.detail && Array.isArray(payload.contribution.detail.DETAILDATA) && payload.contribution.detail.DETAILDATA.length > 0
                        ? payload.contribution.detail.DETAILDATA[0]
                        : {};
                    const startDt = contributionDetail.START_DT || '';
                    const endDt = contributionDetail.END_DT || '';
                    this.contribution.period = (startDt || endDt) ? `${startDt}～${endDt}` : '';
                    // 3.1 明細
                    const bus_group = Array.isArray(contributionDetail.BUS_GROUP) ? contributionDetail.BUS_GROUP : [];
                    this.contribution.detail = []; // 清空陣列
                    console.log('主要業務貢獻度BUS_GROUP', bus_group);
                    if( bus_group ) {
                        bus_group.forEach(item => {
                            // item.S01_IFRS != null ? Number(item.S01_IFRS).toLocaleString() : ''
                                const detailItem = {
                                    BUS_GROUP_LABEL_DESC: item.BUS_GROUP_LABEL_DESC,
                                    PROF_AVE_BALANCE: item.PROF_AVE_BALANCE != null ? parseInt(item.PROF_AVE_BALANCE,10).toLocaleString() : '',
                                    PROF_FUND_INCOME: item.PROF_FUND_INCOME != null ? parseInt(item.PROF_FUND_INCOME,10).toLocaleString() : '',
                                    PROF_FUND_COST: item.PROF_FUND_COST != null ? parseInt(item.PROF_FUND_COST,10).toLocaleString() : '',
                                    PROF_FUND_PROF: item.PROF_FUND_PROF != null ? parseInt(item.PROF_FUND_PROF,10).toLocaleString() : '',
                                    PROF_CMS_PROF: item.PROF_CMS_PROF != null ? parseInt(item.PROF_CMS_PROF,10).toLocaleString() : '',
                                    PROF_OTHER_INCOME: item.PROF_OTHER_INCOME != null ? parseInt(item.PROF_OTHER_INCOME,10).toLocaleString() : '',
                                    PROF_GA_LOS_XC: item.PROF_GA_LOS_XC != null ? parseInt(item.PROF_GA_LOS_XC,10).toLocaleString() : '',
                                    PROF_CLIENT_PROF: item.PROF_CLIENT_PROF!= null ? parseInt(item.PROF_CLIENT_PROF,10).toLocaleString() : '',
                                };
                                if( item.BUS_GROUP_LABEL=="0301" || item.BUS_GROUP_LABEL=="0302" || item.BUS_GROUP_LABEL=="0303" || item.BUS_GROUP_LABEL=="1001" ) {
                                    detailItem.PROF_AVE_BALANCE = 'US' + detailItem.PROF_AVE_BALANCE;
                                }
                                this.contribution.detail.push(detailItem);
                            }
                        );
                    }

                    // 3.2 統計
                    // 數字千位數格式化的邏輯同上，如果是 null 或 undefined 則顯示空字串。
                    const rawContributionStatistics = payload.contribution && payload.contribution.statistics && Array.isArray(payload.contribution.statistics.DETAILDATA) && payload.contribution.statistics.DETAILDATA.length > 0
                        ? payload.contribution.statistics.DETAILDATA[0]
                        : {};
                    const formattedContributionStatistics = {};
                    console.log('主要業務貢獻度統計', rawContributionStatistics);
                    this.contribution_statistics_visible = false;
                    Object.keys(rawContributionStatistics).forEach(key => {
                        // 若全部的數字都是 null 或 ""，則不顯示統計區塊
                        if (rawContributionStatistics[key] !== null && rawContributionStatistics[key] !== undefined && rawContributionStatistics[key] !== '') {
                            this.contribution_statistics_visible = true;
                        }
                        // ROA1,ROA2,ROA3, 丕需要把小數點拿掉, 其他的要拿掉小數點, 並加上千位數, 另外, 如果是 null 或 undefined 則顯示空字串。
                        if( key=='ROA1' || key=='ROA2' || key=='ROA3' ) {
                            formattedContributionStatistics[key] = this.formatNumberWithThousands(rawContributionStatistics[key]);
                        } else {
                            formattedContributionStatistics[key] = this.formatNumberWithThousands(rawContributionStatistics[key],true);
                        }                        
                    });
                    console.log('是否顯示貢獻統計', this.contribution_statistics_visible); 
                    this.contribution.statistics = formattedContributionStatistics;

                    // 4. 授信往來情形 credit_status
                    this.credit_status.main = []; // 清空陣列
                    this.credit_status.child = []; // 清空陣列
                    const creditDetail = payload.credit_status && Array.isArray(payload.credit_status.DETAILDATA) && payload.credit_status.DETAILDATA.length > 0
                        ? payload.credit_status.DETAILDATA[0]
                        : {};
                    console.log("4. credit status", payload.credit_status)
                    const mainDetail = Array.isArray(creditDetail.MAIN_DETAILDATA) ? creditDetail.MAIN_DETAILDATA : [];
                    if( mainDetail.length> 0) {
                        this.credit_status.mainCustomer = mainDetail[0].CUS_NAME || '';
                        this.credit_status.mainCustomerID = '('+ mainDetail[0].CUSIDN + ')' || '';
                    } else {
                        this.credit_status.mainCustomer = '';
                        this.credit_status.mainCustomerID = ''; 
                    }                    
                    this.credit_status.main = mainDetail;
                    //console.log('主要授信往來', this.credit_status.main);
                    // 針對.CONTRACT_AMOUNT和.CREDIT_BAL做千位數格式化
                        this.credit_status.main.forEach(item => {
                            item.CONTRACT_AMOUNT = this.formatNumberWithThousands(item.CONTRACT_AMOUNT);
                            item.CREDIT_BAL = this.formatNumberWithThousands(item.CREDIT_BAL);
                        });
                    // 修改 LOAN_TERM
                    if( this.credit_status.main ) {
                        this.credit_status.main.forEach(item => {
                            item.LOAN_TERM = item.LOAN_SDT + " 至 " + item.LOAN_DDT ;
                        });
                    }
                    
                    // 主要授信往來小計
                    this.credit_status.main_subTotal = (Array.isArray(creditDetail.MAIN_SUBTOTAL) && creditDetail.MAIN_SUBTOTAL.length > 0)
                        ? creditDetail.MAIN_SUBTOTAL[0]
                        : null;
                    if( this.credit_status.main_subTotal ) {
                        const main_subTotal = { CREDIT_ITEM: "小計",
                                                CONTRACT_AMOUNT: this.formatNumberWithThousands(this.credit_status.main_subTotal.SUM_CONTRACT_AMOUNT),
                                                CREDIT_BAL: this.formatNumberWithThousands(this.credit_status.main_subTotal.SUM_CREDIT_BAL),
                                                LOAN_TERM: `本案擔保比率： ${this.credit_status.main_subTotal.COLLATERAL_RATIO}%` ,
                                                COLLATERAL: `貢獻度：${this.formatNumberWithThousands(this.credit_status.main_subTotal.PROF_CLIENT_PROF,true)}`,
                                                REMARKS: ""};
                        this.credit_status.main.push(main_subTotal);                                        
                    }

                    
                    // 關係戶授信往來

                    // 取得全部的 CHILD_DETAILDATA 資料
                    const childDetailData = Array.isArray(creditDetail.CHILD_DETAILDATA) ? creditDetail.CHILD_DETAILDATA : [];
                    // 看起來,要用child_subTotal確認有多少關係戶資料, 再用DETAILDATA[0].CHILD_DETAILDATA取資料
                    // 再做小計, push到child陣列最後一筆
                    const arrayChildSubTotal = Array.isArray(creditDetail.CHILD_SUBTOTAL) ? creditDetail.CHILD_SUBTOTAL : [];
                    console.log('關係戶授信共有', arrayChildSubTotal.length);

                    if( arrayChildSubTotal ) {
                        arrayChildSubTotal.forEach( (subItem) => {
                            //console.log('處理', subItem.CHILD_CUSIDN, '關係戶小計資料');
                            
                            const child_subTotal = { CREDIT_ITEM: "小計",
                                                    CONTRACT_AMOUNT: this.formatNumberWithThousands(subItem.SUM_CONTRACT_AMOUNT),
                                                    CREDIT_BAL: this.formatNumberWithThousands(subItem.SUM_CREDIT_BAL),
                                                    LOAN_TERM: `本案擔保比率： ${subItem.COLLATERAL_RATIO}%` ,
                                                    COLLATERAL: `貢獻度：${this.formatNumberWithThousands(subItem.PROF_CLIENT_PROF,true)}`,
                                                    REMARKS: ""};
                            let childItems = childDetailData.filter(item => item.CHILD_CUSIDN === subItem.CHILD_CUSIDN);
                            // console.log('關係戶',subItem.CHILD_CUSIDN, childItems);
                            // 修改childDetailData的 LOAN_TERM
                            childDetailData.forEach(item => {
                                item.LOAN_TERM = item.LOAN_SDT + " 至 " + item.LOAN_DDT ;
                                item.CUS_NAME = item.CUS_NAME || "關係戶";
                            });
                            // 把小計加入child陣列最後一筆
                            childItems.push(child_subTotal);
                            //console.log('關係戶',subItem.CHILD_CUSIDN, childItems);
                            // 針對CONTRACT_AMOUNT和.CREDIT_BAL做千位數格式化
                            childItems.forEach(item => {
                                item.CONTRACT_AMOUNT = this.formatNumberWithThousands(item.CONTRACT_AMOUNT);
                                item.CREDIT_BAL = this.formatNumberWithThousands(item.CREDIT_BAL);
                            });

                            this.credit_status.child.push(childItems);
                        });                    

                    }
                    
                    if( creditDetail.ALL_SUBTOTAL ) {

                        this.credit_status.all_subTotal = Array.isArray(creditDetail.ALL_SUBTOTAL) ? creditDetail.ALL_SUBTOTAL : [];
                        // 針對.SUM_CONTRACT_AMOUNT和.SUM_CREDIT_BAL做千位數格式化
                        this.credit_status.all_subTotal.forEach(item => {
                            item.SUM_CONTRACT_AMOUNT = this.formatNumberWithThousands(item.SUM_CONTRACT_AMOUNT);
                            item.SUM_CREDIT_BAL = this.formatNumberWithThousands(item.SUM_CREDIT_BAL);
                        });
                        this.credit_status.all_subTotal[0].SUM_CREDIT_ITEM = "總計";
                        this.credit_status.all_subTotal[0].SUM_LOAN_TERM = "本案擔保比率：" + this.credit_status.all_subTotal[0].COLLATERAL_RATIO + "%";
                        this.credit_status.all_subTotal[0].SUM_COLLATERAL_RATIO = "貢獻度：" + this.formatNumberWithThousands(this.credit_status.all_subTotal[0].PROF_CLIENT_PROF,true);
                    }
                    else {
                        this.credit_status.all_subTotal = [];
                    }

                    // console.log('全部授信往來小計', this.credit_status.all_subTotal);

                    this.showCompanyProfileNotice(response);
                } else {
                    // 處理錯誤邏輯
                    console.error('取得公司詳細資料失敗', response.message || (response.data && response.data.message));
                    this.$notify({
                        title: '錯誤',
                        message: response.message || (response.data && response.data.message) || '取得公司詳細資料失敗',
                        type: 'error',
                        duration: 5000
                    });	
                }

            }
            catch (error) {
                console.error('API 呼叫失敗', error);
                this.$notify({
                    title: '錯誤',
                    message: 'API異常，暫時無法取得公司詳細資料，請稍後再試。',
                    type: 'error',
                    duration: 5000
                });	
            }
            finally {
                this.$store.dispatch("loadingHandler", false);
            }

        
        },


        async exportEXCEL() {
            if (!this.canExportOverview) {
                notify({
                    title: '提醒',
                    message: '請先查詢並確認下方有資料後，再執行匯出。',
                    type: 'warning'
                });
                return;
            }

            const exported = await exportCompanyOverviewExcel({
                comBriefVisible: this.comBriefVisible,
                basicInfo: this.basic_info,
                businessStatus: this.business_status,
                contribution: this.contribution,
                creditStatus: this.credit_status,
                fallbackCompanyName: '公司'
            });

            if (exported) {
                const setAudit = {
                    "menu_path": ["潛在客戶智能搜尋", "公司概況表"],
                    "action_type": "export",
                    "action_name": "匯出",
                    "details": {
                        "UniComNm": this.keyword,
                        "FullComName": this.basic_info.CUS_NAME,
                        "exported_pages": ["公司概況表(EXCEL)"]
                    }
                };
                await this.$api.apimgrs.setAuditLog(setAudit);
            }
        },

        async exportPDF() {
            if (!this.canExportOverview) {
                notify({
                    title: '提醒',
                    message: '請先查詢並確認下方有資料後，再執行匯出。',
                    type: 'warning'
                });
                return;
            }

            await exportCompanyOverviewPdf({
                api: this.$api,
                store: this.$store,
                comBriefVisible: this.comBriefVisible,
                basicInfo: this.basic_info,
                businessStatus: this.business_status,
                contribution: this.contribution,
                creditStatus: this.credit_status,
                fallbackCompanyName: '公司'
            });
            // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
            const setAudit = {
                "menu_path": ["潛在客戶智能搜尋", "公司概況表"],
                "action_type": "export",
                "action_name": "匯出",
                "details": {
                    "UniComNm": this.keyword,
                    "FullComName": this.basic_info.CUS_NAME,
                    "exported_pages": ["公司概況表"]
                }
            }
            const resp = await this.$api.apimgrs.setAuditLog(setAudit);            

        },
    },

    async mounted() {
        await this.getFunction();
    }
}
</script>

<style lang="scss" scoped>
#comDetailBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;  
    .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;

            .itemWrap {
                span {
                    margin-right: 10px;
                }
                display: flex;
                flex-direction: row;
                align-items: center;                
                margin-top:10px; 
                margin-bottom: 10px;
                margin-right: 10px;
                width: 100%;
            }
        }    
    .row2 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-end;
        margin-bottom: 10px;
        .el-button {
            margin-right: 10px;
        }
    }
    
  }  

    .content {
        display: flex;
        flex-direction: column;    
        justify-content: flex-start;
        margin-top: 20px;
        padding: 0px 5%;
        .legend {
            display: flex;
            flex-direction: row;
            .legendItem {
                width: 80px;
                margin: 5px 10px;
            }
            
        }

    }   


  .section {
    display: flex;
    flex-direction: column;
    margin: 0 0;    
    background: #fff;
    border-radius: 5px;
    width: 100%;    
    
    .sectionItem {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        padding: 15px;
        
        .itemTitle {
            width: 120px;
            font-weight: bold;
            color: #333;
        }
        .itemValue {
            width: calc(33.33% - 120px - 30px); /* 每組佔1/3，減去標題寬與間距 */
            margin-right: 30px;
            color: #666;
        }
    }
  }
  .section2 , .section3, .section4 {
    display: flex;
    flex-direction: column;
    margin: 0px 0 0 0;    
    background: #fff;
    border-radius: 5px;    
  }

    .sectionHeaderRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .unitText {
        font-size: 14px;
        margin-bottom: 0px;
        text-align: right;
    }


}

::v-deep .el-table .credit-subtotal-row > td {
    background: #FFF6EF !important;
    font-weight: bold;
    text-decoration: underline;
}

::v-deep .el-table th > .cell {
    font-size: 14px;
}

::v-deep .el-table td.align-right-column > .cell {
    text-align: right;
}

</style>